export default function TokensTabPanelController(
  $scope,
  $rootScope,
  loaderService,
  pmDataService,
  pmSharedModelService,
  policyManagementSettingsDialog,
  ssDialogService,
) {
  const vm = this;
  vm.handleEditVariablesClick = _handleEditVariablesClick;
  vm.handleEditEndnotesClick = _handleEditEndnotesClick;

  /** **************************************************
   * Event Handlers
   */

  function _handleEditVariablesClick($event) {
    return _showEditVariablesDialog($event, {
      variables: vm.tokens.variables,
    });
  }

  function _handleEditEndnotesClick($event) {
    return _showEditEndnotesDialog($event, {
      endnotes: vm.tokens.endnotes,
      permissions: vm.permissions,
      policyDocumentId: vm.policyDocumentId,
    });
  }

  /** **************************************************
   * Private Functions
   */

  function _showEditVariablesDialog($event, locals) {
    ssDialogService.dialogs.pm.settingsDialog = ssDialogService.alert(
      policyManagementSettingsDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.settingsDialog);
  }

  function _showEditEndnotesDialog($event, locals) {
    // We cannot reference this dialog directly because of a circular dependency
    $rootScope.$broadcast('pmShowEditEndnotesDialog', locals);
  }
}

TokensTabPanelController.$inject = [
  '$scope',
  '$rootScope',
  'loaderService',
  'pmDataService',
  'pmSharedModelService',
  'policyManagementSettingsDialog',
  'ssDialogService',
];
